import { render, staticRenderFns } from "./notOnshelf2.vue?vue&type=template&id=6ef03888&scoped=true"
import script from "./notOnshelf2.vue?vue&type=script&lang=js"
export * from "./notOnshelf2.vue?vue&type=script&lang=js"
import style0 from "./notOnshelf2.vue?vue&type=style&index=0&id=6ef03888&prod&lang=css"
import style1 from "./notOnshelf2.vue?vue&type=style&index=1&id=6ef03888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef03888",
  null
  
)

export default component.exports